module.exports = __webpack_public_path__ + "static/class-0ed895caeee8c22d4709d0664ce2ce96.png";